module.exports = __webpack_public_path__ + "img/00053.114227a9.webp";